(function (){
    document.addEventListener('DOMContentLoaded', () => {
        const importantBar = document.querySelector('.header__important');
        if (importantBar && importantBar.getElementsByTagName('*').length > 0) {
            const innerElements = importantBar.querySelectorAll('a');
            const lastElement = innerElements[innerElements.length - 1];
            const rect = lastElement.getBoundingClientRect();
            const minX = (rect.left + window.scrollX + rect.width) * -1;
            let prevTimeStamp;

            function animationFrame(timestamp) {
                if (prevTimeStamp === undefined) {
                    prevTimeStamp = timestamp;
                }
                requestAnimationFrame(animationFrame);
                if (timestamp - prevTimeStamp > 1000 / 30) {
                    const transformX = 1;
                    innerElements.forEach((element, index) => {
                        let currentX = element.style.transform.match(/(-?[0-9\.]+)/g) ? element.style.transform.match(/(-?[0-9\.]+)/g) : '0';

                        if (minX > currentX) {
                            element.classList.remove('header__important-transition');
                            currentX = window.innerWidth;
                            setTimeout(() => {
                                element.classList.add('header__important-transition');
                            }, 300)
                        }
                        element.style.transform = "translateX(" + (currentX - 1) + "px)";
                        prevTimeStamp = timestamp
                    })
                }
            }

            requestAnimationFrame(animationFrame);
        }
    })
})();